import fishing from '@/assets/svg/fishing.svg'
import cargo from '@/assets/svg/cargo.svg'
import tanker from '@/assets/svg/tanker.svg'
import underwater from '@/assets/svg/underwater.svg'
import diving from '@/assets/svg/diving.svg'
import passenger from '@/assets/svg/passenger.svg'
import unknown from '@/assets/svg/unknown.svg'
import other from '@/assets/svg/other.svg'
import { CableVessel } from '@/server/MakeSenseApp-backend'

export const degreesToRadians = (degrees: number) => {
  const pi = Math.PI
  return degrees * (pi / 180)
}

export const getVesselIcon = (vessel: CableVessel | undefined) => {
  if (vessel === undefined) {
    return other
  }

  switch (vessel.vesselType) {
    case 0:
      return fishing
    case 1:
      return cargo
    case 2:
      return tanker
    case 3:
      return underwater
    case 4:
      return diving
    case 5:
      return passenger
    case 6:
      return unknown
    default:
      return other
  }
}
